<div class="map-panel" style="flex: 1">
  <mat-toolbar color="primary" style="height: 50px; font-size: 12px;">
    <mat-checkbox (change)="toggleViewOption('tickets', $event)" [checked]="mapManager.showJobLayer">Tickets
    </mat-checkbox>
    <span class="spacer"></span>
    <mat-checkbox (change)="toggleViewOption('routes', $event)" [checked]="mapManager.showRouteLayer">Routes
    </mat-checkbox>
    <span class="spacer"></span>
    <mat-checkbox (change)="toggleViewOption('shifts', $event)" [checked]="mapManager.showAvailabilityLayer">Shift
      Locations
    </mat-checkbox>
    <span class="spacer"></span>
    @if (bingMode) {
    <mat-select (selectionChange)="updateMapStyle($event)" [value]="imageryStyle" style="width:120px">
      @for (style of bingStyles; track style) {
      <mat-option [value]="style.value">
        {{ style.display }}
      </mat-option>
      }
    </mat-select>
    }

    <button (click)="mapManager.calculateZoomToFit()" matTooltip="Fit Content to View" mat-icon-button>
      <mat-icon fontIcon="fa-expand" fontSet="fas"></mat-icon>
    </button>
    <!--    <button mat-flat-button (click)="mapManager.calculateZoomToFit()" color="accent">Refit View</button>-->
  </mat-toolbar>
  <div class="livemap" id="livemap" style="flex:1"></div>
</div>
<div [style.display]="mapManager.displayOverlay ? 'block' : 'none'" class="tooltip" id="tooltip">
  @for (tooltip of mapManager.tooltipText; track tooltip) {
  <div class="job">
    {{ tooltip }}
  </div>
  }
</div>
